<template>
    <l-map 
        style="height: 100%; width: 100%; background-color: #ffffff;" 
        :crs="crs" 
        :zoom="recinto.zoom"
        :minZoom="-5"
        :center="[alto_center, ancho_center]"
        :maxBounds="[[0, 0], [recinto.alto, recinto.ancho]]"
        :options="{
            attributionControl: false
        }"
    >
        <l-image-overlay 
            :url="recinto.imagen_general" 
            :bounds="[[0, 0], [recinto.alto, recinto.ancho]]"
        />

        <template v-for="(seat, index) in seats">
            <l-circle
                :key="index"
                :lat-lng="seat.pos"
                :radius="recinto.radio"
                :color="getColorButaca(seat)"
                @click="click(seat)"
                :fillColor="getColorButaca(seat)"
                :fillOpacity="1"
                :weight="0"
            >
                <l-tooltip>
                    <div class="row p-1">
                        <div class="col-12 mb-3">
                            <b>{{ seat.zona_nombre }}</b>, Fila: {{ seat.row }}, Butaca: {{ seat.seat }}
                        </div>
                        <div class="col-12">
                            <b>{{ getEstadoButaca(seat) }}</b>
                            <hr/>
                        </div>
                        <div class="col-12">
                            <template v-for="precio in seat.precios">
                                <p :key="precio.id">
                                    - {{ precio.descripcion }} <b>({{ precio.precio | formatear_precio }})</b>
                                </p>
                            </template>
                        </div>
                    </div>
                </l-tooltip>
            </l-circle>
        </template>                     
    </l-map>
</template>

<script>    
    import { LMap, LImageOverlay, LCircle, LTooltip } from 'vue2-leaflet';
    import L from 'leaflet';

    export default {
        props: {
            seats: Array,
            recinto: Object
        },
        data() {
            return {
                crs:  L.CRS.Simple,
                alto_center: this.recinto.alto / 2,
                ancho_center: this.recinto.ancho / 2,
            }
        },
        methods: {            
            click(seat) {
                if(seat.status != 'ocupado') {
                    if(seat.status == 'seleccionado') {
                        seat.status = 'disponible';
                        this.$emit('eliminar-butaca', seat);
                    } else if(seat.status == 'disponible') {
                        seat.status = 'seleccionado';
                        this.$emit('seleccionar-butaca', seat);
                    } 
                }                               
            },
            getColorButaca(seat) {
                switch (seat.status) {
                    case 'disponible':
                        if(seat.precios.length > 0) {
                            return '#01F700';
                        } else {
                            return '#cc0000';
                        }
						
                    case 'ocupado':
                        return '#cc0000';
                    case 'seleccionado':
                        return '#8ca9d9';
                }
            },
            getEstadoButaca(seat) {
                switch (seat.status) {
                    case 'disponible':
                        if(seat.precios.length > 0) {
                            return 'Disponible';
                        } else {
                            return 'No disponible';
                        }						
                    case 'ocupado':
                        return 'No disponible';
                    case 'seleccionado':
                        return 'Seleccionada';
                }
            }
        },
        components: {
            LMap,
            LImageOverlay,
            LCircle,
            LTooltip
        },
    }
</script>

<style scoped>
    .vue2leaflet-map {
        z-index: 1;
    }
</style>
